import { ReactNode } from 'react';
import { adornment } from './Adornment.css';

interface AdornmentProps {
  position?: 'top-right' | 'right' | 'left';
  children: ReactNode;
}

export const Adornment: React.FC<AdornmentProps> = ({ position = 'right', children }) => {
  return <span className={adornment({ position })}>{children}</span>;
};
